<template>
    <div class="address">
        <el-dialog title="发货地址" :visible.sync="dialogVisible" width="768px" :before-close="handleClose">
            <div class="main scroll-auto" v-loading="load">
                <div class="infoData">
                  <!--  v-show="tableData && tableData.length < 3" -->
                    <el-form ref="refFormInline" :inline="true" :model="formInline" :rules="rule" class="demo-form-inline" label-width="100px" label-position="left">
                        <el-row :gutter="40">
                            <el-col :span="12">
                                <el-form-item label="仓库名" prop="title">
                                    <el-input v-model="formInline.title" placeholder="请输入仓库名" clearable style="width: 220px"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="发货地址" prop="area">
                                    <el-cascader
                                        style="width: 100%"
                                        clearable
                                        filterable
                                        v-model="formInline.area"
                                        :options="city_list"
                                        :props="{ expandTrigger: 'hover', label: 'label', value: 'value' }"
                                        :show-all-levels="false"
                                        @change="deliveryAddressChange"
                                    ></el-cascader>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="详细地址" class="w100" prop="address">
                                    <el-input v-model="formInline.address" placeholder="请输入详细地址" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="发货人姓名" prop="sender_name">
                                    <el-input v-model="formInline.sender_name" placeholder="请输入发货人姓名" clearable style="width: 220px"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="发货人电话" prop="sender_cellphone">
                                    <el-input v-model="formInline.sender_cellphone" placeholder="请输入发货人电话" clearable style="width: 220px"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" style="text-align: right">
                                <el-form-item style="margin-right: 24px">
                                    <el-button @click="reset">重 置</el-button>
                                    <el-button type="primary" @click="onSubmit(1)" :loading="btnload" v-if="tableData.length<3&&edit_id==0" >保 存</el-button>
                                    <el-button type="primary" @click="onSubmit(2)" :loading="btnload" v-else>编 辑</el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                    <p><span style="color: red; margin-right: 14px">详细地址用于物流上门揽件地址，请准确填写</span>最多可以填写三个地址</p>
                </div>

                <el-table :data="tableData" style="width: 100%; margin-top: 24px">
                    <el-table-column prop="title" label="仓库名"> </el-table-column>
                    <el-table-column prop="province" label="发货地址">
                        <template slot-scope="scope">
                            <el-tooltip :content="`${scope.row.province}${scope.row.city}${scope.row.district}`" placement="top" effect="light">
                                <span>{{ `${scope.row.province}${scope.row.city}${scope.row.district}` | strFmt }}</span>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column prop="address" label="详细地址">
                        <template slot-scope="scope">
                            <el-tooltip :content="scope.row.address" placement="top" effect="light">
                                <span>{{ scope.row.address | strFmt }}</span>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column prop="sender_name" label="发货人姓名"> </el-table-column>
                    <el-table-column prop="sender_cellphone" label="发货人电话"> </el-table-column>
                    <el-table-column prop="address" label="操作">
                        <template slot-scope="scope">
                            <div class="link">
                                <el-link type="primary" @click="Edit(scope.row.id)">编辑</el-link>
                               <!--  <el-link type="danger" @click="deleteWarehouseFunc(scope.row.id)">删除</el-link> -->
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import address from "@/assets/area_data.json";
export default {
    data() {
        // 手机号验证
        var checkMobile = (rule, value, cb) => {
            const regMobile = /^(0|86|17951)?(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])[0-9]{8}$/;

            if (regMobile.test(value)) {
                return cb();
            }
            cb(new Error("请输入合法的手机号"));
        };
        return {
            btnload: false,
            load: false,
            edit_false: false,
            city_list: address,
            dialogVisible: false,
            formInline: {
                title: "",
                sender_name: "",
                sender_cellphone: "",
                area: [],
                areaStr: [],
                address: "",
            },
            rule: {
                area: [
                    {
                        required: true,
                        trigger: "change",
                        message: "请选择发货地址",
                    },
                ],
                title: [
                    {
                        required: true,
                        trigger: "blur",
                        message: "请填写仓库名",
                    },
                ],
                sender_name: [
                    {
                        required: true,
                        trigger: "blur",
                        message: "请填写发货人姓名",
                    },
                ],
                sender_cellphone: [
                    {
                        required: true,
                        trigger: "blur",
                        message: "请填写发货人手机号",
                    },
                    { validator: checkMobile, trigger: "blur" },
                ],
                address: [
                    {
                        required: true,
                        trigger: "blur",
                        message: "请填写详细地址",
                    },
                ],
            },
            tableData: [],
            edit_id: 0,
        };
    },
    filters: {
        strFmt(val) {
            if (val) {
                if (val.length > 5) {
                    return val.substring(0, 5) + "...";
                }
                return val;
            }
            return "-";
        },
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    mounted() {
      
    },
    methods: {
        ...mapActions({
            getWarehouseList: "brand/getWarehouseList",
            warehouseDetail: "brand/warehouseDetail",
            createWarehouse: "brand/createWarehouse",
            editWarehouse: "brand/editWarehouse",
            deleteWarehouse: "brand/deleteWarehouse",
        }),
        deleteWarehouseFunc(id) {
            this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let params = {
                        token: this.getToken,
                        id: id,
                    };
                    this.deleteWarehouse(params).then(({ data }) => {
                        if (data.code == 1) {
                            this.$message.success("删除成功！");
                            this.getList();
                            this.$emit("initOption");
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        getDetail(id) {
            let params = {
                token: this.getToken,
                id: id,
            };
            this.warehouseDetail(params).then(({ data }) => {
                if (data.code == 1) {
                    let { title, sender_name, sender_cellphone, province, city, district, province_code, city_code, district_code, address } = data.data;
                    this.formInline = {
                        title: title,
                        sender_name: sender_name,
                        sender_cellphone: sender_cellphone,
                        areaStr: [province, city, district],
                        area: [province_code, city_code, district_code],
                        address: address,
                    };
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        // initAddress() {
        //     this.address.forEach((item) => {
        //         item.children = item.cities.city;
        //         if (item.cities.city && item.cities.city.length > 0) {
        //             item.cities.city.forEach((v) => {
        //                 v.children = v.areas.area;
        //             });
        //         }
        //     });
        //     this.city_list = this.address;
        // },
        Edit(id) {
          console.log(this.tableData,'555')
            this.edit_id = id;
            this.edit_false=true
            this.getDetail(id);
        },
        getList() {
            console.log('获取地址列表 :>> ', );
            this.load = true;
            let postData = {
                pageSize: 10,
                pageIndex: 1,
                merchantId:this.$getSessionStorage("userid"),
            };
            this.getWarehouseList(postData).then(res => {
                this.load = false;
                if (res.code == 10000) {
                    this.tableData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        onSubmit(val) {
          if (val==1) {
            this.edit_id=0
          }
         console.log(this.edit_id ,'this.edit_id ')
            if (this.tableData.length >= 3 && this.edit_id ==0) {
                return this.$message.warning("最多可以填写三个地址!");
            }
            this.$refs.refFormInline.validate((valid) => {
                if (valid) {
                    this.btnload = true;
                    let { title, sender_name, sender_cellphone, area, areaStr, address } = this.formInline;
                    let params = {
                        token: this.getToken,
                        title: title,
                        sender_name: sender_name,
                        sender_cellphone: sender_cellphone,
                        province: areaStr[0],
                        city: areaStr[1],
                        district: areaStr[2],
                        province_code: area[0],
                        city_code: area[1],
                        district_code: area[2],
                        address: address,
                    };
                    let url;
                   
                    if (this.edit_id == 0) {
                        url = this.createWarehouse;
                    } else {
                        params.id = this.edit_id;
                        url = this.editWarehouse;
                    }
                    url(params).then(({ data }) => {
                        this.btnload = false;
                        if (data.code == 1) {
                            this.$message.success(`${this.edit_id != 0 ? "修改" : "添加"}成功！`);
                            this.getList();
                            this.$emit("initOption");
                            if (this.edit_id==0) {
                               this.reset();
                            }
                           
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        reset() {
            this.$refs.refFormInline.resetFields();
            this.formInline = {
                title: "",
                sender_name: "",
                sender_cellphone: "",
                area: [],
                areaStr: [],
                address: "",
            };
            this.edit_id = 0;
        },
        handleClose() {
            this.dialogVisible = false;
            this.$refs.refFormInline.resetFields();
            this.formInline = {
                title: "",
                sender_name: "",
                sender_cellphone: "",
                area: [],
                areaStr: [],
                address: "",
            };
            this.tableData = [];
            this.load = false;
        },
        deliveryAddressChange(val) {
            this.formInline.areaStr = [];
            if (val.length > 0) {
                val.forEach((item) => {
                    this.formInline.areaStr.push(this.getItem(this.city_list, item));
                    console.log(  this.formInline.areaStr);
                });
            }
        },
        getItem(list, id) {
            if (!list instanceof Array) {
                return null;
            }
            for (let i in list) {
                let item = list[i];
                if (item.value === id) {
                    return item.label;
                } else {
                    if (item.children) {
                        let value = this.getItem(item.children, id);
                        if (value) {
                            return value;
                        }
                    }
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.main {
    height: 550px;
    overflow-x: hidden;
}
.w100 {
    width: 100%;
    ::v-deep .el-form-item__content {
        width: calc(100% - 124px);
    }
}
::v-deep .el-table th {
    background: #e8e8e8;
}
.link {
    a {
        margin: 0 8px;
    }
}
</style>